export const workSheetConstants = {

    REQUEST_CREATE_WORKSHEET:'REQUEST_CREATE_WORKSHEET',
    RECEIVE_CREATE_WORKSHEET: 'RECEIVE_CREATE_WORKSHEET',
    ERROR_CREATE_WORKSHEET: 'ERROR_CREATE_WORKSHEET',

    REQUEST_ORIENTATION_WORKSHEET:'REQUEST_ORIENTATION_WORKSHEET',
    RECEIVE_ORIENTATION_WORKSHEET: 'RECEIVE_ORIENTATION_WORKSHEET',
    ERROR_ORIENTATION_WORKSHEET: 'ERROR_ORIENTATION_WORKSHEET',

    // REQUEST_GET_WORKSHEET
    REQUEST_GET_WORKSHEET:'REQUEST_GET_WORKSHEET',
    RECEIVE_GET_WORKSHEET:'RECEIVE_GET_WORKSHEET',
    GET_WORKSHEET_ERROR:'GET_WORKSHEET_ERROR',

    // REQUEST_SAVE_WORKSHEET 
    REQUEST_SAVE_WORKSHEET: 'REQUEST_SAVE_WORKSHEET',
    RECEIVE_SAVE_WORKSHEET: 'RECEIVE_SAVE_WORKSHEET',
    SAVE_WORKSHEET_ERROR: 'SAVE_WORKSHEET_ERROR',

    // REQUEST_SHARE_WORKSHEET
    REQUEST_SHARE_WORKSHEET:'REQUEST_SHARE_WORKSHEET',
    RECEIVE_SHARE_WORKSHEET:'RECEIVE_SHARE_WORKSHEET',
    SHARE_WORKSHEET_ERROR:'SHARE_WORKSHEET_ERROR',

    // REQUEST_REMOVE_SHARING_WORKSHEET
    REQUEST_REMOVE_SHARING_WORKSHEET:'REQUEST_REMOVE_SHARING_WORKSHEET',
    RECEIVE_REMOVE_SHARING_WORKSHEET:'RECEIVE_REMOVE_SHARING_WORKSHEET',
    REMOVE_SHARING_WORKSHEET_ERROR:'REMOVE_SHARING_WORKSHEET_ERROR',

    // REQUEST_UPDATE_WORKSHEET
    REQUEST_UPDATE_WORKSHEET:'REQUEST_UPDATE_WORKSHEET',
    RECEIVE_UPDATE_WORKSHEET:'RECEIVE_UPDATE_WORKSHEET',
    UPDATE_WORKSHEET_ERROR:'UPDATE_WORKSHEET_ERROR',

    // REQUEST_GET_SHARED_USERS
    REQUEST_GET_SHARED_USERS:'REQUEST_GET_SHARED_USERS',
    RECEIVE_GET_SHARED_USERS:'RECEIVE_GET_SHARED_USERS',
    GET_SHARED_USERS_ERROR:'GET_SHARED_USERS_ERROR',

    // REQUEST_SAVE_COMMENT
    REQUEST_SAVE_COMMENT:'REQUEST_SAVE_COMMENT',
    RECEIVE_SAVE_COMMENT:'RECEIVE_SAVE_COMMENT',
    SAVE_COMMENT_ERROR:'SAVE_COMMENT_ERROR',

    // REQUEST_GET_COMMENT_LIST
    REQUEST_GET_COMMENT_LIST:'REQUEST_GET_COMMENT_LIST',
    RECEIVE_GET_COMMENT_LIST:'RECEIVE_GET_COMMENT_LIST',
    GET_COMMENT_LIST_ERROR:'GET_COMMENT_LIST_ERROR',

    // REQUEST_GET_WORKSHEET_DETAILS
    REQUEST_GET_WORKSHEET_DETAILS:'REQUEST_GET_WORKSHEET_DETAILS',
    RECEIVE_GET_WORKSHEET_DETAILS:'RECEIVE_GET_WORKSHEET_DETAILS',
    GET_WORKSHEET_DETAILS_ERROR:'GET_WORKSHEET_DETAILS_ERROR',

    // REQUEST_GET_SHARED_WITH_USERS
    REQUEST_GET_SHARED_WITH_USERS:'REQUEST_GET_SHARED_WITH_USERS',
    RECEIVE_GET_SHARED_WITH_USERS:'RECEIVE_GET_SHARED_WITH_USERS',
    GET_SHARED_WITH_USERS_ERROR:'GET_SHARED_WITH_USERS_ERROR',

    // REQUEST_WEAK_AREA
    REQUEST_WEAK_AREA:'REQUEST_WEAK_AREA',
    RECEIVE_WEAK_AREA:'RECEIVE_WEAK_AREA',
    WEAK_AREA_ERROR:'WEAK_AREA_ERROR',

}


// WEBPACK FOOTER //
// ./src/_constants/workSheet.constants.js